import React from 'react';
import { BookOpen, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100 py-16 px-4 sm:px-6 lg:px-8" data-id="element-50">
      <div className="max-w-7xl mx-auto" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-52">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-53">
            <div className="flex items-center gap-2 mb-4" data-id="element-54">
              <div className="bg-indigo-600 p-1.5 rounded-md" data-id="element-55">
                <BookOpen className="w-4 h-4 text-white" data-id="element-56" />
              </div>
              <span className="font-bold text-lg tracking-tight text-slate-900" data-id="element-57">
                Global Nova Pro
              </span>
            </div>
            <p className="text-slate-500 text-sm mb-6 leading-relaxed" data-id="element-58">
              Tu destino principal para descubrir, comprar y disfrutar de los
              mejores e-books en formato digital.
            </p>
            <div className="flex items-center gap-4" data-id="element-59">
              <a href="#" className="text-slate-400 hover:text-indigo-600 transition-colors" data-id="element-60">
                <Twitter className="w-5 h-5" data-id="element-61" />
              </a>
              <a href="#" className="text-slate-400 hover:text-indigo-600 transition-colors" data-id="element-62">
                <Instagram className="w-5 h-5" data-id="element-63" />
              </a>
              <a href="#" className="text-slate-400 hover:text-indigo-600 transition-colors" data-id="element-64">
                <Linkedin className="w-5 h-5" data-id="element-65" />
              </a>
            </div>
          </div>

          {/* Tienda Links */}
          <div data-id="element-66">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-67">Tienda</h4>
            <ul className="space-y-3 text-sm text-slate-500" data-id="element-68">
              <li data-id="element-69">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-70">
                  Catálogo completo
                </a>
              </li>
              <li data-id="element-71">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-72">
                  Novedades
                </a>
              </li>
              <li data-id="element-73">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-74">
                  Más vendidos
                </a>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-76">
                  Ofertas especiales
                </a>
              </li>
            </ul>
          </div>

          {/* Soporte Links */}
          <div data-id="element-77">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-78">Soporte</h4>
            <ul className="space-y-3 text-sm text-slate-500" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-81">
                  Centro de ayuda
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-83">
                  Formatos compatibles
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-85">
                  Devoluciones
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-indigo-600 transition-colors" data-id="element-87">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-88">
            <h4 className="font-semibold text-slate-900 mb-4" data-id="element-89">Boletín</h4>
            <p className="text-sm text-slate-500 mb-4" data-id="element-90">
              Suscríbete para recibir recomendaciones y ofertas exclusivas.
            </p>
            <div className="flex gap-2" data-id="element-91">
              <input type="email" placeholder="Tu email" className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500" data-id="element-92" />
              <button className="bg-slate-900 text-white p-2 rounded-lg hover:bg-indigo-600 transition-colors" data-id="element-93">
                <Mail className="w-5 h-5" data-id="element-94" />
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-95">
          <p className="text-sm text-slate-500" data-id="element-96">
            © {new Date().getFullYear()} Global Nova Pro. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-97">
            <a href="#" className="hover:text-slate-900" data-id="element-98">
              Privacidad
            </a>
            <a href="#" className="hover:text-slate-900" data-id="element-99">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>;
}